<template>
    <div class="flex flex-col lg:h-[calc(100vh-4rem)] lg:overflow-hidden xl:h-screen">
        <div class="flex flex-1 lg:overflow-y-hidden">
            <slot />
        </div>
    </div>
</template>
